"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("@emotion/react");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_expansion_1 = require("@ryerson/frontend.expansion");

var KeywordSearchResultsContent_1 = require("./KeywordSearchResultsContent");

var SearchResultsWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 13px rgba(0, 0, 0, 0.1417),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\tmin-width: 483px;\n\tmax-width: 515px;\n\tposition: absolute;\n\tz-index: 99;\n\ttop: ", ";\n\tbackground: ", ";\n"])), function (props) {
  return props.isSticky ? "50px" : "125px";
}, function (props) {
  return props.theme.colors.primary.white;
});
var TypographyTitleBar = (0, styled_1.default)(frontend_typography_1.Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground: ", ";\n\tpadding: 5px 10px;\n\twidth: 100%;\n\tdisplay: inline-block;\n\tcolor: ", ";\n"])), function (props) {
  return props.theme.colors.primary.darkGray;
}, function (props) {
  return props.theme.colors.primary.white;
});
var categoriesBoxStyles = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\t&:first-of-type {\n\t\tmargin-right: 5px;\n\t}\n"])));
var categoriesListWrapperStyles = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tpadding: 10px;\n"])));
var MobileResultsWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\tz-index: 99;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
var MobileResultsAccordionWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tpadding: 20px;\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});

var KeywordSearchResults = function KeywordSearchResults(_ref) {
  var results = _ref.results,
      isSticky = _ref.isSticky,
      isMobile = _ref.isMobile,
      keywordsConfig = _ref.keywordsConfig;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language;

  var _ref4 = results || {},
      _ref4$keyword = _ref4.keyword,
      keyword = _ref4$keyword === void 0 ? "" : _ref4$keyword;

  var lighterGray = theme.colors.primary.lighterGray;
  var resultFeatures = keywordsConfig[language][keyword];

  var renderDesktopResults = function renderDesktopResults() {
    return (0, jsx_runtime_1.jsxs)(SearchResultsWrapper, {
      theme: theme,
      isSticky: isSticky,
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
        style: categoriesBoxStyles,
        children: [(0, jsx_runtime_1.jsx)(TypographyTitleBar, {
          size: "xs",
          theme: theme,
          children: KeywordSearchResultsContent_1.KeywordSearchResultsContent[language].featuresText
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          gutter: 5,
          direction: "column",
          style: categoriesListWrapperStyles,
          children: resultFeatures && resultFeatures.map(function (_a, index) {
            var title = _a.title,
                props = __rest(_a, ["title"]);

            return (0, react_1.createElement)(frontend_navigation_1.Link, Object.assign({}, props, {
              key: index,
              target: "_blank"
            }), title);
          })
        })]
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: categoriesBoxStyles,
        children: (0, jsx_runtime_1.jsx)(TypographyTitleBar, {
          size: "xs",
          theme: theme,
          children: KeywordSearchResultsContent_1.KeywordSearchResultsContent[language].artliclesText
        })
      })]
    });
  };

  var renderMobileResults = function renderMobileResults() {
    return (0, jsx_runtime_1.jsx)(MobileResultsWrapper, {
      children: (0, jsx_runtime_1.jsx)(MobileResultsAccordionWrapper, {
        direction: "column",
        className: "accordion-search",
        bgColor: lighterGray,
        children: (0, jsx_runtime_1.jsx)(frontend_expansion_1.Accordion, {
          variant: "line",
          multiple: true,
          children: (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
            header: "Features",
            circled: true,
            maxHeight: "1000px",
            defaultOpen: true,
            children: resultFeatures && resultFeatures.map(function (_a, index) {
              var title = _a.title,
                  props = __rest(_a, ["title"]);

              return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                style: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\tpadding: 8px 0px;\n\t\t\t\t\t\t\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, Object.assign({}, props, {
                  target: "_blank",
                  children: title
                }))
              }, index);
            })
          })
        })
      })
    });
  };

  return isMobile ? renderMobileResults() : renderDesktopResults();
};

exports.default = KeywordSearchResults;